import { useEffect, useState } from "react";
import { prize, prizeType } from "../../../../utils/timer";
import { TournamentResponse } from "../../../../api/tournament";
import * as S from "../styles";
interface PrizeListProps {
  data: TournamentResponse | null;
  subPrizeFont: number;
}

const PrizeList = ({ data, subPrizeFont }: PrizeListProps) => {
  const [visibleRanks, setVisibleRanks] = useState<number[]>([
    4, 5, 6, 7, 8, 9, 10,
  ]);
  const groupSize = 7;

  useEffect(() => {
    if (!data) return;
    const totalRanks = data.moneyInChip.length;
    if (totalRanks <= 11) return;

    const totalGroups = Math.ceil((totalRanks - 3) / groupSize);
    let currentGroupIndex = 1;

    const interval = setInterval(() => {
      setVisibleRanks((prevRanks) => {
        const groupStart = 4 + currentGroupIndex * groupSize;
        const groupEnd = Math.min(groupStart + groupSize - 1, totalRanks);

        currentGroupIndex = (currentGroupIndex + 1) % totalGroups;

        return Array.from(
          { length: groupEnd - groupStart + 1 },
          (_, i) => groupStart + i,
        );
      });
    }, 9000);

    return () => clearInterval(interval);
  }, [data?.moneyInChip.length]);

  if (!data?.moneyInChip) return null;

  return (
    <S.Timer2PrizeListContainer>
      <div className="header">PRIZE POOL</div>
      <S.Timer2PrizeListWrapper subPrizeFont={subPrizeFont}>
        {data.moneyInChip.map((item, index) =>
          index < 3 ? (
            <div className={`item rank${index}`} key={index}>
              <div className="rank">
                {`${index + 1}${
                  index === 0 ? "st" : index === 1 ? "nd" : "rd"
                }`}
              </div>
              <div className="prize-wrapper">
                <div className="prize">
                  <span>{prize(data, item, index)}</span> {prizeType(item)}
                </div>
                {item.subPrize && (
                  <div className="sub-prize">{item.subPrize}</div>
                )}
              </div>
            </div>
          ) : visibleRanks.includes(index + 1) ? (
            <S.Timer2PrizeListItemWrapper
              subPrizeFont={subPrizeFont}
              key={index}
              length={data ? data?.moneyInChip.length : 0}
            >
              <div className="rank">{index + 1}th</div>
              <div className="prize-wrapper">
                <div className="prize">
                  <span>{prize(data, item, index)}</span> {prizeType(item)}
                </div>
                {item.subPrize && (
                  <div className="sub-prize">{item.subPrize}</div>
                )}
              </div>
            </S.Timer2PrizeListItemWrapper>
          ) : (
            ""
          ),
        )}
      </S.Timer2PrizeListWrapper>
    </S.Timer2PrizeListContainer>
  );
};

export default PrizeList;
